import get from 'lodash-es/get'

import ArchivePage from '../../js/components/page/archive-page'
import { mapNodeToArticle } from '../../js/graphql/utils'
import { usePagination } from '../../js/hooks/pagination'
import { MONTH } from '../../js/constants'

function Page(props) {
  const { data, year, month, page } = props

  const posts = get(data, 'posts.nodes', [])
  const hasNext = get(data, 'posts.pageInfo.hasNextPage', false)
  const hasPrev = page > 1

  const entries = posts.map(mapNodeToArticle)

  const rel = usePagination(
    MONTH,
    {
      year,
      month,
      page,
      hasNext,
      hasPrev,
    },
  )

  return (
    <ArchivePage
      year={year}
      month={month}
      rel={rel}
      entries={entries}
    />
  )
}

export default Page
